export default "__VITE_ASSET__Dmd6gyof__"